module.exports = __webpack_public_path__ + "img/logo-mini-white.e2e625b0.png";